import React from 'react';
import { type ActionButtonIcon } from '@bbk/retention-sdk/contracts/layout';
import { ExitSurveyIcons } from '@bbkAdminUtils/icons/funnel-icons';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

import './action-button-helpers.scss';

export const WrapIcon: ReactFCC<{ styles?: React.CSSProperties }> = ({
  styles,
  children,
}) => (
  <span className="bbk-simple-action-icon" style={styles}>
    {children}
  </span>
);

type Props = {
  icon?: ActionButtonIcon;
  styles?: React.CSSProperties;
};

const ActionButtonIcons: React.FC<Props> = (props) => {
  const { icon = '', styles } = props;

  switch (icon.toLowerCase()) {
    case 'mail':
    case 'bbk-esi-message':
      return (
        <WrapIcon styles={styles}>
          {ExitSurveyIcons['bbk-esi-message']?.svg}
        </WrapIcon>
      );
    case 'phone':
    case 'bbk-esi-phone':
      return (
        <WrapIcon styles={styles}>
          {ExitSurveyIcons['bbk-esi-phone']?.svg}
        </WrapIcon>
      );
    case 'movie':
    case 'bbk-esi-movie-alt':
      return (
        <WrapIcon styles={styles}>
          {ExitSurveyIcons['bbk-esi-movie-alt']?.svg}
        </WrapIcon>
      );
    case 'chat':
    case 'bbk-esi-chat':
      return (
        <WrapIcon styles={styles}>
          {ExitSurveyIcons['bbk-esi-chat']?.svg}
        </WrapIcon>
      );
    default: {
      const exitSurveyIcon = ExitSurveyIcons[icon];
      if (exitSurveyIcon) {
        return <WrapIcon styles={styles}>{exitSurveyIcon.svg}</WrapIcon>;
      }

      return null;
    }
  }
};

export default ActionButtonIcons;
